import React from 'react';
import '../style/BottomSection.scss';
import emblem from "../assets/images/veria_emblem.png";

function BottomSection({title, description, cardText}) {
  return (
      <div id={'BottomSection'}>
        <div className="section-wrapper">
          <div className="section-title">{title}</div>
          <div className="section-description">{description}</div>
          <div className="section-card-wrapper">
            <div className="section-card-text">{cardText}</div>
            <img className="section-card-img" src={emblem} alt={''}/>
          </div>
        </div>
      </div>
  );
}

export default BottomSection;